import { useDatasetContext } from "../useDatasetContext";

import { DatasetEventsTable } from "./DatasetEventsTable";

/**
 * Renders the "Events" tab of the Dataset detail view, mounted at the
 * `events` child route under the dataset detail layout in DatasetsRoutes.
 */
export function DatasetEvents() {
  const { datasetId } = useDatasetContext();
  return <DatasetEventsTable datasetId={datasetId} />;
}
